<!-- InfoTagPopup.vue -->
<template>
  <div
    class="filter-popup info-popup"
    v-click-outside="close"
    :data-type="type"
  >
    <div class="popup-header" v-if="title">
      <h4>{{ title }}</h4>
    </div>

    <!-- Contenu principal -->
    <div class="popup-content">
      <div class="popup-message">
        {{ message }}
      </div>

      <!-- Contenu complémentaire (slot) -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { clickOutside } from "@/directives/click-outside";

export default {
  name: "InfoTagPopup",
  directives: {
    clickOutside,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: "top",
      validator: (value) => ["top", "bottom", "left", "right"].includes(value),
    },
    triggerRef: {
      type: null,
      default: null,
    },
    type: {
      type: String,
      default: "info",
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.calculatePosition();
    });
  },

  methods: {
    close() {
      this.$emit("close");
    },

    calculatePosition() {
      if (!this.triggerRef) return;

      const popupElement = this.$el;
      const triggerRect = this.triggerRef.getBoundingClientRect();

      // Obtenir la position et les dimensions du container
      const containerWidth = popupElement.offsetWidth;
      const containerHeight = popupElement.offsetHeight;

      // Positionnement initial basé sur la position demandée
      let top, left;

      switch (this.position) {
        case "top":
          // Positionner au-dessus du trigger
          top = triggerRect.top - containerHeight - 8;
          left = triggerRect.left + triggerRect.width / 2 - containerWidth / 2;
          break;
        case "bottom":
          // Positionner sous le trigger
          top = triggerRect.bottom + 8;
          left = triggerRect.left + triggerRect.width / 2 - containerWidth / 2;
          break;
        case "left":
          // Positionner à gauche du trigger
          top = triggerRect.top + triggerRect.height / 2 - containerHeight / 2;
          left = triggerRect.left - containerWidth - 8;
          break;
        case "right":
          // Positionner à droite du trigger
          top = triggerRect.top + triggerRect.height / 2 - containerHeight / 2;
          left = triggerRect.right + 8;
          break;
      }

      // Ajuster si le popup sort de l'écran
      if (left < 8) left = 8;
      if (left + containerWidth > window.innerWidth - 8) {
        left = window.innerWidth - containerWidth - 8;
      }
      if (top < 8) top = 8;
      if (top + containerHeight > window.innerHeight - 8) {
        top = window.innerHeight - containerHeight - 8;
      }

      // Appliquer les positions calculées
      popupElement.style.top = `${top}px`;
      popupElement.style.left = `${left}px`;
      popupElement.setAttribute("data-position", this.position);
    },
  },
};
</script>

<style scoped>
.filter-popup {
  position: fixed;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 220px;
  z-index: 1000;
  padding: 16px;
  animation: fadeIn 0.2s ease;
}

.info-popup::before {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  background: white;
  transform: rotate(45deg);
  z-index: -1;
}

.info-popup[data-position="top"]::before {
  bottom: -5px;
  left: 50%;
  margin-left: -5px;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.1);
}

.info-popup[data-position="bottom"]::before {
  top: -5px;
  left: 50%;
  margin-left: -5px;
  box-shadow: -2px -2px 3px rgba(0, 0, 0, 0.1);
}

.info-popup[data-position="left"]::before {
  right: -5px;
  top: 50%;
  margin-top: -5px;
  box-shadow: 2px -2px 3px rgba(0, 0, 0, 0.1);
}

.info-popup[data-position="right"]::before {
  left: -5px;
  top: 50%;
  margin-top: -5px;
  box-shadow: -2px 2px 3px rgba(0, 0, 0, 0.1);
}

.popup-header {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}

.popup-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.popup-content {
  font-size: 13px;
  line-height: 1.4;
  width: 100%;
}

.popup-message {
  color: #666;
  margin-bottom: 8px;
  word-wrap: break-word;
  white-space: normal;
}

/* Animation d'apparition */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
